import Model from './Model'
export default class Appointment extends Model {

    resource()
    {
        return 'appointments'
    }
}
